import { createAsyncAction } from "typesafe-actions";
import type {
    IntentSelectedTopicDto,
    IntentTopicDescriptionDto,
} from "app/pages/sales-intelligence/sub-modules/intent/types/dto";
import type { FetchError } from "app/pages/sales-intelligence/types";
import type { IntentApprovedTerms } from "app/pages/sales-intelligence/sub-modules/intent/types/common";

const INTENT_MODULE = "intent";

export const fetchIntentCategories = createAsyncAction(
    `@@si/${INTENT_MODULE}/FETCH_INTENT_CATEGORY_REQUEST`,
    `@@si/${INTENT_MODULE}/FETCH_INTENT_CATEGORY_SUCCESS`,
    `@@si/${INTENT_MODULE}/FETCH_INTENT_CATEGORY_FAILURE`,
)<void, IntentTopicDescriptionDto, FetchError>();
export const fetchSelectedIntentTopics = createAsyncAction(
    `@@si/${INTENT_MODULE}/FETCH_SELECTED_INTENT_TOPICS_REQUEST`,
    `@@si/${INTENT_MODULE}/FETCH_SELECTED_INTENT_TOPICS_SUCCESS`,
    `@@si/${INTENT_MODULE}/FETCH_SELECTED_INTENT_TOPICS_FAILURE`,
)<void, IntentSelectedTopicDto, FetchError>();

export const fetchIntentUserApproval = createAsyncAction(
    `@@si/${INTENT_MODULE}/FETCH_INTENT_USER_APPROVAL_REQUEST`,
    `@@si/${INTENT_MODULE}/FETCH_INTENT_USER_APPROVAL_SUCCESS`,
    `@@si/${INTENT_MODULE}/FETCH_INTENT_USER_APPROVAL_FAILURE`,
)<void, IntentApprovedTerms, FetchError>();

export const saveIntentUserApproval = createAsyncAction(
    `@@si/${INTENT_MODULE}/SAVE_INTENT_USER_APPROVAL_REQUEST`,
    `@@si/${INTENT_MODULE}/SAVE_INTENT_USER_APPROVAL_SUCCESS`,
    `@@si/${INTENT_MODULE}/SAVE_INTENT_USER_APPROVAL_FAILURE`,
)<void, void, FetchError>();
